import { useContext } from "react";
import ReportShowAllCheckbox from "components/ReportShowAllCheckbox";
import { TrendReportContext } from "contexts/TrendReportContext/TrendReportContext";

const TopFiveSecondaryFailureCodesCheckbox = () => {
    const {
        showAllSecondaryFailureCodes,
        selectedSecondaryFailureCode,
        selectedPreviousSecondaryFailureCode,
        handleShowAllSecondaryFailureCodesChange,
        handleSetSelectedSecondaryFailureCode,
        handleSelectedPreviousSecondaryFailureCodeChange,
    } = useContext(TrendReportContext);

    return (
        <ReportShowAllCheckbox
            checked={showAllSecondaryFailureCodes}
            onChange={(_, checked) => {
                handleShowAllSecondaryFailureCodesChange(checked);
                if (checked) {
                    handleSelectedPreviousSecondaryFailureCodeChange(selectedSecondaryFailureCode);
                    handleSetSelectedSecondaryFailureCode(undefined);
                } else {
                    handleSetSelectedSecondaryFailureCode(selectedPreviousSecondaryFailureCode);
                }
            }}
        />
    );
};

export default TopFiveSecondaryFailureCodesCheckbox;
